<template>
    <card title="Change your greeting">
        <div class="row">
            <label class="col-md-2 col-form-label">Greeting</label>
            <div class="col-md-8">
                <el-select
                    class="select-primary"
                    size="small"
                    :placeholder="subject + ' greeting'"
                    v-model="greeting"
                >
                    <el-option
                        v-for="option in availableGreetings"
                        class="select-primary"
                        :value="option.value"
                        :label="option.label"
                        :key="option.label"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="col-md-2">
                <base-button
                    class="float-right"
                    type="primary"
                    :loading="saving"
                    @click="save">Save
                </base-button>
            </div>
        </div>
    </card>
</template>
<script>
    import axios from "axios";
    import swal from "sweetalert2";

    export default {
        name: 'change-subject-greeting-card',
        props: [
            'classroom',
            'subject',
            'url'
        ],
        data() {
            return {
                greeting: '',
                availableGreetings: [],
                saving: false,
            };
        },
        mounted() {
            this.loadCurrentGreeting();
            this.loadAvailableGreetings();
        },

        methods: {
            loadAvailableGreetings() {
                return axios({
                    url: this.baseAPIURL + 'classroom/' + this.classroom.id + '/greeting/' + this.subject,
                    method: 'GET',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.availableGreetings = resp.data;
                });
            },
            loadCurrentGreeting() {
                return axios({
                    url: this.baseAPIURL + 'classroom/' + this.classroom.id + '/greeting/' + this.subject + '/current',
                    method: 'GET',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.greeting = resp.data;
                });
            },
            save() {
                swal.fire({
                    title: 'Are you sure?',
                    text: "This will change the greeting for this subject. Any custom greetings will be overwritten!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, change it!'
                }).then((result) => {
                    if (result.value) {
                        this.saving = true;
                        axios.post(this.baseAPIURL + 'classroom/' + this.classroom.id + '/greeting/' + this.subject, {
                            'greeting': this.greeting || null,
                        }).then((resp) => {
                            this.$notify({
                                message: 'Subject greeting updated!',
                                type: "success",
                                icon: "fal fa-save",
                            });
                        }).catch(() => {
                            this.$notify({
                                message: 'Oops, something went wrong! ',
                                type: "error",
                                icon: "fal fa-times",
                            });
                        }).finally(() => {
                            this.saving = false;
                        });
                    }
                });
            },
        }
    }
</script>
